
import { Vue, Component, Prop } from "vue-property-decorator";
import { moneyFormat } from "@/utils/util";

export interface ITableColomns {
  key: string; // 列标识
  title: string; // 列名
  width: number; // 列宽
  align: string; // 列对齐 "right" "left" "center"
  sort: boolean; // 开启列排序 true false
  order: string; // asc 升序 desc 降序
  dataType: string; // 数据类型，percent 比例 | amount 金额 | discount 折扣 | proportion 占比
}

@Component
export default class CustomTable extends Vue {
  @Prop({ type: String, default: "33px" }) thH;
  @Prop({ type: String, default: "51px" }) rowH;
  @Prop({ type: Number }) scrollX;
  @Prop({ type: Boolean, default: true }) showReportIcon; // 是否显示报表按钮
  @Prop({ type: Boolean, default: true }) showEven; // 是否显示偶数行加深背景
  moneyFormat = moneyFormat;

  @Prop({
    default: () => {
      return [];
    },
  })
  columns!: Array<ITableColomns>; // 表格列配置
  @Prop({
    default: () => {
      return [];
    },
  })
  dataSource!: Array<Record<string, any>>; // 表格数据

  orderBy(item: ITableColomns) {
    if (item.order === "asc") {
      item.order = "desc";
    } else if (item.order === "desc") {
      item.order = "";
    } else {
      item.order = "asc";
    }
    this.$emit("orderByColumn", item);
  }
  toPercent(value: string) {
    // 避免出现 7.000000000000001情况
    return Math.round(Number(value) * 10000) / 100;
  }

  toAmount(value: string) {
    return parseFloat(Number(value).toFixed(2));
  }
  gotoReport(row: any) {
    if (!row.categoryId) return;
    this.$emit("gotoReport", row);
  }
  openChild(row: any) {
    if (!row.childrens || !row.categoryId) return;
    row.open = !row.open;
    this.$emit("expand", row);
  }
}
